<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="639px" :before-close="closeModal">
    <div class="pt-5 px-5">
        <div class="mb-3 d-flex justify-content-center">
            <AlertExclamationRegister />
        </div>
        <h3 class="c-ndarkthree bold mb-2 text-center">
            Deseja alterar conta principal?
        </h3>
        <p class="c-ndarkfour regular text-center">
            Se escolher essa conta como principal, a partir de agora irá receber todos
            os pagamentos da plataforma através dela:
        </p>
        <div class="row mt-4 border-box p-3 d-flex align-items-center justify-content-center">
            <div class="col break-col">
                <caption>
                    banco
                </caption>
                <h5 class="c-ndarkfour bold">
                    {{ bankName | formatName }}
                </h5>
            </div>
            <div class="col-3">
                <caption>
                    agência
                </caption>
                <h5 class="c-ndarkfour bold">
                    {{ bankInfo.agency }}
                </h5>
            </div>
            <div class="col-3">
                <caption>
                    c/c
                </caption>
                <h5 class="c-ndarkfour bold">
                    {{ bankInfo.account }}
                </h5>
            </div>
        </div>
    </div>

    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link :class="`${getPrimaryColor} c-ndarkfour mr-4`" to="" @click.native="closeModal">
            Cancelar
        </router-link>

        <Button @click="changeAccount" :color="getPrimaryColor">
            Ok, alterar
        </Button>
    </span>
</el-dialog>
</template>

<script>
import AlertExclamationRegister from '@/components/icons/AlertExclamationRegister'
import banksList from '@/utils/banksList'
export default {
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        bankInfo: {
            required: true,
            default: {
                bank: '',
                bankAgency: '',
                account: '',
            }
        }
    },
    computed: {
        bankName() {
            const bankEntry = banksList.find(bank => bank.COMPE == this.bankInfo.bank)
            if (bankEntry) {
                return `${bankEntry.COMPE} - ${bankEntry.LongName}`
            } else {
                return ''
            }
        },
    },
    components: {
        AlertExclamationRegister,
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        changeAccount() {
            this.$emit('changeAccount')
        },
    }

}
</script>

<style>

</style>